export const emptyStateDescription =
  "Once the claims are processed and we receive the final amounts, your remaining balances will be adjusted to reflect the accurate total";

export const emptyStateTitle =
  "Balance update is pending from your providers and insurance";
